import React, { Component } from "react";
import { PropTypes } from 'prop-types';
import {
  PagesHeadingWrapper,
  NoChangeSpace,
  ContentContainerSpace
} from "../Step1Setup/styles";
import {
  ConfirmationMessage,
  ContributeSubhead,
  SubHeadSpace,
  ConfirmationMessageWrap,
  GhostButtonComponentStyles,
  ButtonsWrap,
  PrimaryButtonComponentStyles,
  ConfirmationMessageImage,
  AccountInformationWrapper
} from "./styles";
import tickMark from "../../../../assets/icons/confirmation-tick.svg";
import history from "../../../../history/history";
import { Types, ContentMessage, ContentProvider }  from "../../../../CommonComponents/ContentMessages";
import { connect } from "react-redux";
import {selectHeader} from "../../../../actions/globalActions";
import { recordError } from "../../../../utils/commonUtil";
import { basicInfo } from "../DefaultPropTypes";
import { AccountCreatedDerivedStates } from "../selectors";

export class AccountCreated extends Component {
  handleContributeLater = () => {
    try {
      history.push("/open-an-additional-account/contribute-later/");
      window.scrollTo(0, 0);
    } catch (error) {
      recordError(error);
    }
  };
  goToRoute(link,SelectName){
    try {
      if (SelectName != "") {
        this.props.selectHeader(SelectName);
      }
      history.push(link);
    } catch (error) {
      recordError(error);
    }
  }
  render() {
    return (
      <ContentContainerSpace role="main">
        <ContentProvider types={[Types.GET_CONFIRMATION_MESSAGE]} pages={['OOA']}>
        <div className="fluid">
          <NoChangeSpace role="navigation" data-test="breadcrumb-component">
            <span>Home</span> <span>></span> <span>Open account</span>
          </NoChangeSpace>
          <PagesHeadingWrapper role={false} data-test="account-created-title">Account Created</PagesHeadingWrapper>
          <SubHeadSpace data-test="account-created-description" marginBottom="50px" mobileMarginBottom="30px">
            Well done! Now that the account is established, it's the perfect
            time to make a contribution.
          </SubHeadSpace>
          <ConfirmationMessageWrap>
            <ConfirmationMessageImage data-test="confirmation-tick" src={tickMark} alt="Confirmation Tick" />
            <ConfirmationMessage>
            <ContentMessage data-test="confirmation-message" type={[Types.GET_CONFIRMATION_MESSAGE]} page="OOA" property="field_success_message" html={true} defaultMessage="Success! You have created an additional account." />
            </ConfirmationMessage>
          </ConfirmationMessageWrap>
          <SubHeadSpace data-test="accountCreated-desc-1" marginBottom="50px" mobileMarginBottom="30px">
            You can transfer funds from your first account into the additional account or contribute directly to the account. 
          </SubHeadSpace>
          <ContributeSubhead data-test="accountCreated-desc-2">
            Contribute to your philanthropic account
          </ContributeSubhead>
          <AccountInformationWrapper>
            <ContributeSubhead data-test="accountCreated-desc-3">Account No: &nbsp;</ContributeSubhead>
            <SubHeadSpace data-test="accountNumber"> {this.props.accNum}</SubHeadSpace>
          </AccountInformationWrapper>
          <AccountInformationWrapper>
            <ContributeSubhead data-test="accountCreated-desc-4">Account Name: &nbsp;</ContributeSubhead>
            <SubHeadSpace data-test="accountName">The {this.props.fundName} Fund</SubHeadSpace>
          </AccountInformationWrapper>

          <SubHeadSpace marginBottom="50px" mobileMarginBottom="40px" data-test="accountCreated-desc-5">
            Congratulations! You successfully created a philanthropic account
            with Vanguard Charitable.
          </SubHeadSpace>
          <ButtonsWrap>
            <GhostButtonComponentStyles data-test="contributeLater-btn" onClick={this.handleContributeLater}>
              Contribute later
            </GhostButtonComponentStyles>
              <PrimaryButtonComponentStyles data-test="contributeNow-btn" onClick={this.goToRoute.bind(this,'/contributions/make-a-contribution','Make a contribution')} className="contributenow_tooltip">
                Contribute now
              </PrimaryButtonComponentStyles>
          </ButtonsWrap>
        </div>
        </ContentProvider>
      </ContentContainerSpace>
    );
  }
}

const mapStateToProps = state => ({
  ...AccountCreatedDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => {
  return {
    selectHeader: data => dispatch(selectHeader(data))
  };
};

AccountCreated.propTypes = {
  accNum: PropTypes.string,
  fundName: PropTypes.string,
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  primaryUserInfo: basicInfo,
  selectHeader: PropTypes.func,
  staticContext: PropTypes.any,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountCreated);
